import { FC, useEffect } from "react";
import menuStore from "../../store/menu";
import { observer } from "mobx-react-lite";
import { useHandleForm } from "../../hooks/useHandleForm";
import { Controller } from "react-hook-form";
import {
  FormField,
  IButton,
  ICheckbox,
  ISelect,
  Layout,
  ExpandedTable,
  Skeleton,
} from "../../ui-kit";
import Paths from "../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import { useStatusMessage } from "../../hooks/useStatusMessage";
import { CheckOutlined, StopOutlined } from "@ant-design/icons";

import styles from "./MenuCustomizing.module.scss";
const { SelectSkeleton } = Skeleton;

const MenuCustomizing: FC = observer(() => {
  useBreadcrumbs(Paths.adminMenu);

  const {
    flatMenuWithDisabled,
    getMenuWithDisabled,
    menuTreeWithDisabled,
    menuStatus,
    menuWithDisabledLoading,
  } = menuStore;

  const { control, handleSubmit, register, reset, watchAllField } =
    useHandleForm();

  useStatusMessage(menuStatus);

  useEffect(() => {
    getMenuWithDisabled();
  }, []);

  useEffect(() => {
    if (watchAllField.id) {
      const chosen = flatMenuWithDisabled.find(
        (i) => i.id === watchAllField.id,
      );
      if (chosen) {
        reset({ ...chosen, delete: false });
      }
    } else {
      reset({ id: null });
    }
  }, [watchAllField.id]);

  const handleDelete = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    menuStore.deleteMenuItem(watchAllField.id);
    reset({
      id: null,
      url: null,
      name: null,
    });
  };

  const onSubmit = async (data, e: React.SyntheticEvent) => {
    menuStore.updateNavigationItem(data);
    reset({
      id: null,
      url: null,
      name: null,
    });
  };

  return (
    <Layout type="white">
      <div className={styles.wrapper}>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          {menuWithDisabledLoading.value ? (
            <SelectSkeleton />
          ) : (
            <Controller
              control={control}
              name="id"
              render={({ field }) => (
                <ISelect
                  field={field}
                  optionsArr={menuTreeWithDisabled}
                  placeholder="Пункт меню"
                />
              )}
            />
          )}
          <FormField
            type="text"
            label="Название"
            name={"name"}
            currentValue={watchAllField.name}
            register={register}
            // error={errors.name?.message}
            isRequired
          />
          <FormField
            type="text"
            label="Урл"
            name={"url"}
            currentValue={watchAllField.url}
            register={register}
            // error={errors.name?.message}
            isRequired
          />
          <Controller
            control={control}
            name="enabled"
            render={({ field: { value, onChange } }) => (
              <ICheckbox
                checked={value}
                onChange={onChange}
                label={"Опубликован"}
                className={styles.checkbox}
              />
            )}
          />
          <div className={styles.action}>
            <IButton disabled={!watchAllField.id}>Отправить</IButton>
            <IButton
              onClick={handleDelete}
              className={styles.deleteButton}
              disabled={!watchAllField.id}
            >
              Удалить
            </IButton>
          </div>
        </form>
        {watchAllField.id && (
          <ExpandedTable
            scroll={{ x: "max-content" }}
            className={styles.table}
            data={[watchAllField]}
            columns={[
              {
                title: "ID",
                dataIndex: "id",
                key: "id",
                width: "6%",
              },
              {
                title: "Название",
                dataIndex: "name",
                key: "name",
                width: "24%",
              },
              {
                title: "Урл",
                dataIndex: "url",
                key: "url",
                width: "60%",
              },
              {
                title: "Опубликовано",
                dataIndex: "enabled",
                key: "enabled",
                width: "10%",
                render: (value) => {
                  return value ? (
                    <CheckOutlined style={{ color: "#38a390" }} />
                  ) : (
                    <StopOutlined style={{ color: "rgba(253, 94, 94, 1)" }} />
                  );
                },
              },
            ]}
          />
        )}
      </div>
    </Layout>
  );
});

export default MenuCustomizing;
